import { AreaType } from '../../../../com/ibm/tw/commons/enums/global/area.type';

export class CcmotlginFaqViewForm {

    area: string = AreaType.TW;

    tabId: string = 'system';

    /** 系統問題Q1 */
    systemQ1: boolean = false;
    /** 系統問題Q2 */
    systemQ2: boolean = false;
    /** 系統問題Q3 */
    systemQ3: boolean = false;
    /** 系統問題Q4 */
    systemQ4: boolean = false;
    /** 系統問題Q5 */
    systemQ5: boolean = false;
    /** 系統問題Q6 */
    systemQ6: boolean = false;
    /** 系統問題Q7 */
    systemQ7: boolean = false;
    /** 系統問題Q8 */
    systemQ8: boolean = false;
    /** 系統問題Q9 */
    systemQ9: boolean = false;
    /** 系統問題Q10 */
    systemQ10: boolean = false;
    /** 系統問題Q11 */
    systemQ11: boolean = false;

    /** 作業問題Q1 */
    operatorQ1: boolean = false;
    /** 作業問題Q2 */
    operatorQ2: boolean = false;
    /** 作業問題Q3 */
    operatorQ3: boolean = false;
    /** 作業問題Q4 */
    operatorQ4: boolean = false;
    /** 作業問題Q5 */
    operatorQ5: boolean = false;
    /** 作業問題Q6 */
    operatorQ6: boolean = false;
    /** 作業問題Q7 */
    operatorQ7: boolean = false;
    /** 作業問題Q8 */
    operatorQ8: boolean = false;
    /** 作業問題Q9 */
    operatorQ9: boolean = false;
    /** 作業問題Q10 */
    operatorQ10: boolean = false;

}
